import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from '@/context/LanguageContext';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ManagementPage from '@/pages/ManagementPage';
import AcademicsPage from '@/pages/AcademicsPage';
import AchievementsPage from '@/pages/AchievementsPage';
import ActivitiesPage from '@/pages/ActivitiesPage';
import RulesPage from '@/pages/RulesPage';
import NewsPage from '@/pages/NewsPage';
import GalleryPage from '@/pages/GalleryPage';
import EventsPage from '@/pages/EventsPage';
import ContactPage from '@/pages/ContactPage';
import AdmissionsPage from '@/pages/AdmissionsPage';
import AdmissionFormPage from '@/pages/AdmissionFormPage';
import ResourcesPage from '@/pages/ResourcesPage';
import StudentPortal from '@/pages/StudentPortal';
import ParentPortal from '@/pages/ParentPortal';
import TeacherDashboard from '@/pages/TeacherDashboard';
import AdminPanel from '@/pages/AdminPanel';
import DigitalCodingProgram from '@/pages/DigitalCodingProgram';
import EnglishSpeakProgram from '@/pages/EnglishSpeakProgram';
import BranchHome from "./pages/BranchHome";

import '@/App.css';

function App() {
  return (
    <BrowserRouter>

      {/* Scroll to top when route changes */}
      <ScrollToTop />

      <AuthProvider>
        <LanguageProvider>
          <div className="App scroll-smooth">

            <Routes>

              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/branch/pithampur" element={<BranchHome />} />
              <Route path="/management" element={<ManagementPage />} />
              <Route path="/academics" element={<AcademicsPage />} />
              <Route path="/achievements" element={<AchievementsPage />} />
              <Route path="/activities" element={<ActivitiesPage />} />
              <Route path="/tekielab" element={<DigitalCodingProgram />} />
              <Route path="/speaklab" element={<EnglishSpeakProgram />} />
              <Route path="/rules" element={<RulesPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admissions" element={<AdmissionsPage />} />
              <Route path="/admission-form" element={<AdmissionFormPage />} />
              <Route path="/resources" element={<ResourcesPage />} />

              {/* Open Pages */}
              <Route path="/student-portal" element={<StudentPortal />} />
              <Route path="/parent-portal" element={<ParentPortal />} />
              <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
              <Route path="/admin" element={<AdminPanel />} />

              {/* Redirect unknown routes */}
              <Route path="*" element={<Navigate to="/" replace />} />

            </Routes>

            <Toaster position="top-right" />

          </div>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;